// extracted by mini-css-extract-plugin
module.exports = {"thematix-trade-card":"ThematixWhyTrade_thematix-trade-card__hOhEY","hidden-link":"ThematixWhyTrade_hidden-link__hYVvt"};